/**
 * Menu Section Component
 * Renders category heading + all its filtered item cards.
 * Hidden entirely if no items pass the dietary filter.
 */

import { getCurrentLanguage } from '../../../i18n';
import { renderMenuItemCard } from './menu-item-card';
import { itemMatchesFilters } from './category-tabs';
import type { MenuCategory, CartItem } from '../types';
import type { ActiveFilters } from './diet-filter';

export function renderMenuSection(
  cat: MenuCategory,
  cart: Map<string, CartItem>,
  filters: ActiveFilters,
): string {
  const lang = getCurrentLanguage();

  const visibleItems = cat.items.filter(
    (item) => itemMatchesFilters(item.tags, filters)
  );

  if (visibleItems.length === 0) return '';

  const name = (cat.name as Record<string, string>)[lang] || cat.name.en;

  const itemsHtml = visibleItems
    .sort((a, b) => a.sort - b.sort)
    .map((item) => renderMenuItemCard(item, cart.get(item.id)?.qty ?? 0))
    .join('');

  return `
    <section
      id="menu-section-${cat.id}"
      class="menu-section"
      data-category="${cat.id}"
      style="margin-bottom:8px;"
    >
      <div style="
        padding:10px 16px 8px;
        background:#f5f5f5;
        font-size:13px;font-weight:700;
        color:#444;text-transform:uppercase;letter-spacing:0.5px;
        border-top:1px solid #e0e0e0;
      ">${name}</div>
      <div class="menu-section-items" style="background:#fff;">
        ${itemsHtml}
      </div>
    </section>
  `;
}
